import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-soil-guidelines',
  templateUrl: './soil-guidelines.component.html',
  styleUrls: ['./soil-guidelines.component.scss']
})
export class SoilGuidelinesComponent {
  
  biodiversityPdfUrl: SafeResourceUrl;
  policyPdfUrl: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {
    this.biodiversityPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl('assets/biodiversity.pdf#toolbar=1&navpanes=1&scrollbar=1');
    this.policyPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl('assets/policy.pdf#toolbar=1&navpanes=1&scrollbar=1');
  }

}